module.exports = __webpack_public_path__ + "img/asus-rog-strix.5a85c23c.jpg";